<template>
  <v-select
    v-model="modelFilter"
    dense
    clearable
    single-line
    hide-details="true"
    :items="options"
    :item-text="text"
    :item-value="value"
    item-color="primary"
    class="mt-0"
    prepend-inner-icon="mdi-magnify"
  />
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'FilterSelectOptions',
  props: {
    options: Array,
    value: String,
    text: String
  },
  data() {
    return {
      modelFilter: null
    }
  },
  watch: {
    modelFilter(val) {
      this.$emit('filterValueChange', val);
    }
  }
});
</script>
